import { Star } from "lucide-react";

export function Stars({ rating, size = "h-4 w-4" }) {
  return (
    <div className="flex gap-0.5" aria-label={`${rating} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`${size} ${i <= rating ? "fill-amber-400 text-amber-400" : "fill-slate-200 text-slate-200"}`} />
      ))}
    </div>
  );
}

const AVATAR_COLORS = ["bg-teal-600", "bg-sky-600", "bg-navy-600", "bg-emerald-600", "bg-cyan-700", "bg-indigo-600"];

export default function ReviewCard({ review, testId }) {
  const initials = review.name
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  const color = AVATAR_COLORS[(review.name.charCodeAt(0) + review.name.length) % AVATAR_COLORS.length];

  return (
    <article
      data-testid={testId}
      className="flex h-full min-w-0 flex-col rounded-2xl bg-white p-5 shadow-sm ring-1 ring-slate-200/80 transition-shadow duration-300 hover:shadow-lg hover:shadow-navy-900/5 sm:p-6"
    >
      <div className="flex flex-wrap items-center gap-3">
        <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full font-heading text-sm font-bold text-white ${color}`}>
          {initials}
        </span>
        <div className="min-w-0">
          <p className="truncate font-heading font-semibold text-navy">{review.name}</p>
          <Stars rating={review.rating} />
        </div>
        <span className="ml-auto shrink-0 rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-slate-500">
          {review.source || "Google"}
        </span>
      </div>
      <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-600">“{review.text}”</p>
    </article>
  );
}
